import { Panel } from "@/dom/components/Panel/Panel";
import { PanelBody } from "@/dom/components/Panel/PanelBody";
import { PanelHeader } from "@/dom/components/Panel/PanelHeader";
import { useResourcesState } from "@/state/resourcesState";
import React, { useEffect, useMemo, useState } from "react";
import css from "./SelectFurniture.module.css";
import { FurnitureCard } from "./FurnitureCard";
import { useFurnitureManagementState } from "@/state/furnitureManagementState";
import { Row } from "@/dom/components/Panel/Row";
import { Tabs } from "@/dom/components/Tabs/Tabs";
import { Furniture } from "@/state/Furniture";
import { FurnitureDetails } from "./FurnitureDetails";
import _ from "lodash";

export const SelectFurniture: React.FC = () => {
    const furniture = useResourcesState((state) => state.furniture);
    const tabs = useMemo(
        () =>
            _.uniqBy(
                Object.values(furniture)
                    .map((f) => ({
                        label: f.data.category,
                        tabKey: f.data.category,
                    }))
                    .filter((tab) => tab.tabKey !== "System"),
                "tabKey"
            ),
        [furniture]
    );

    const [activeTabKey, setActiveTabKey] = useState(tabs[0]?.tabKey);
    const [selectedFurniture, setSelectedFurniture] = useState<Furniture>();

    useEffect(() => {
        setActiveTabKey(tabs[0]?.tabKey);
    }, [tabs]);

    const filteredFurniture = useMemo(() => {
        return Object.values(furniture).filter(
            (furniture) => furniture.data.category === activeTabKey
        );
    }, [activeTabKey, furniture]);

    const materials = useResourcesState((state) => state.materials);
    const createFurnitureInstance = useFurnitureManagementState(
        (state) => state.createFurnitureInstance
    );

    if (selectedFurniture) {
        return (
            <FurnitureDetails
                furniture={selectedFurniture}
                onBack={() => setSelectedFurniture(undefined)}
                onAdd={() => createFurnitureInstance(selectedFurniture, materials)}
            />
        );
    }

    return (
        <Panel>
            <PanelHeader title="Каталог" />
            <PanelBody>
                <Row>
                    <Tabs tabs={tabs} onSelect={setActiveTabKey} activeTabKey={activeTabKey} />
                </Row>
                <div className={css.grid2}>
                    {filteredFurniture.map((furniture) => (
                        <FurnitureCard
                            key={furniture.id}
                            furniture={furniture}
                            onAdd={() => createFurnitureInstance(furniture, materials)}
                            onSelect={() => setSelectedFurniture(furniture)}
                        />
                    ))}
                </div>
            </PanelBody>
        </Panel>
    );
};
